// extracted by mini-css-extract-plugin
export default {"custom-breadcrumb":"Favorite_custom-breadcrumb__bHAOx","breadcrumb-item":"Favorite_breadcrumb-item__qJ5ZQ","custom-button":"Favorite_custom-button__z9ISQ"};